import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './AnchorItem.css';
import React, { useEffect, useRef, useState } from 'react';
import { get } from '../../utils';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { useHistory } from 'react-router-dom';
var commonStyles = "cq6qp7s";
var scrollToRef = function scrollToRef(ref) {
  return ref.current.scrollIntoView({
    behavior: 'smooth'
  });
};
var AnchorItem = function AnchorItem(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var title = get(fields, 'data.datasource.title.jss.value');
  var id = "anchor-item-".concat(Math.random().toString(36).slice(2));
  var venueTitle = get(fields, 'data.contextItem.title.jss.value');
  var tabTextAnalytics = get(fields, 'data.tabTextAnalytics');
  var anchorUrlParameter = params['Anchor Url Parameter'];
  var componentRef = useRef(null);
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    offsetTop = _useState2[0],
    setOffsetTop = _useState2[1];
  var history = useHistory();
  var hash = history.location.hash && history.location.hash.split('#')[1] || null;
  var handleScroll = function handleScroll() {
    // @ts-ignore
    if (componentRef && componentRef.current && componentRef.current.offsetTop != offsetTop)
      // @ts-ignore
      setOffsetTop(componentRef.current.offsetTop || 0);
  };
  useEffect(function () {
    if (anchorUrlParameter && componentRef && hash && anchorUrlParameter == hash) {
      scrollToRef(componentRef);
    }
  }, [offsetTop]);
  useEffect(function () {
    if (anchorUrlParameter && componentRef && hash && anchorUrlParameter == hash) {
      window.addEventListener('scroll', handleScroll);
      return function () {
        window.removeEventListener('scroll', handleScroll);
      };
    }
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    "data-id": "anchor-item",
    "data-anhor": anchorUrlParameter,
    ref: componentRef,
    onClick: function onClick() {
      tealiumClickFunc(tealiumMergeClickData(tabTextAnalytics, params), [venueTitle, title]);
    },
    id: id,
    "data-title": title,
    className: commonStyles
  });
};
export default AnchorItem;